




import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import Impersonate from './banners/impersonate.vue';

@Component({
  components: {Impersonate}
})
export default class AppAlerts extends Vue {
  
}
